import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-ultimas-consultas',
  templateUrl: './consulta-ultimas-consultas.component.html',
  styleUrls: ['./consulta-ultimas-consultas.component.scss']
})
export class ConsultaUltimasConsultasComponent implements OnInit {
  title = "ÚLTIMAS CONSULTAS";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
